import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FormattedMessage } from "react-intl";

const pStyle = {
  fontSize: "18px"
  // marginBottom: "16px",
};

export default function EbayGuide() {
  return (
    <Box>
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="ebay.step1"
          values={{
            a: (...chunks) => {
              return (
                <a
                  className="text"
                  href="mailto: customer-integration@eclear.com"
                >
                  {chunks}
                </a>
              );
            },
            br: <br />
          }}
        />
      </Typography>{" "}
      <br />
      {/* <Typography component="p" sx={pStyle}>
        <FormattedMessage
          id="contactSupport"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />,
          }}
        />
      </Typography> */}
    </Box>
  );
}
